module.exports = __webpack_public_path__ + "static/media/giatricotloi1.050dc0ea.png";